import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import newTemplate from '@/views/private/qma/qmaTemplate/newTemplate/newTemplate.vue'
import deleteTemplate from '@/views/private/qma/qmaTemplate/deleteTemplate/deleteTemplate.vue'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {newTemplate, deleteTemplate},
  data () {
    return {
      columTemplate: ['ITEM AVALIAÇÃO', 'CÓDIGO DO PIT', 'STATUS', 'DT. DE CRIAÇÃO', 'REVISÃO', ''],
      formSearch: {},
      dataTemplatePIT: [],
      tipoFluxo: 'PIT',
      codigo: null,
      pes: null,
      id: null,
      template: null
    }
  },

  mounted () {
  },
  methods: {
    desativarAtivar (id) {
      qmaTemplate.inativaAtivaQMATemplate(id)
        .then((Response) => {
          loading.pop()
          this.onLoad()
        }).catch(Error => {
          loading.pop()
          toast.warning('Não foi possível alterar o status')
        })
    },
    onLoad () {
      loading.push()
      this.formSearch.FluxoTemplate = 1
      qmaTemplate.GetQMATemplateParaTodosTemplatesGrid(this.$refs.tableGridsTemplatePIT.pagingLimit, this.$refs.tableGridsTemplatePIT.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridsTemplatePIT.LoadAllByData(Response)
          this.dataTemplatePIT = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.warning('dados não encontrado')
        })
    },
    openFiles () {
      document.getElementById('impor-ex-price').click()
    },
    imporTable (e) {
      if (e.target.files.length === 0) return
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let data = new FormData()
      data.append('Excel', e.target.files[0])
      loading.push()
      qmaTemplate.ImportableByQMALVPIT(false, true, data, conf)
        .then(Response => {
          toast.success('Excel importado com sucesso!!', 'Excel')
          this.onLoad()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.warning('Formato invalido!!', 'Excel')
        })
    },
    DetailsExpense (value) {
      this.$emit('templateQMADetalhes', value)
    },
    abrirPopUp () {
      this.$refs.newtablepit.popUptAdd()
    },
    abrirPopUpEditar (dadosTemplate) {
      this.$refs.newtablepit.popUptEdicao(dadosTemplate)
    },
    excluirTemplate (dadosTemplate) {
      this.id = dadosTemplate.id
      this.template = dadosTemplate.itemAvaliacao
      this.$refs.deletetablepit.popUptExlusao()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/templateQmaPIT/components/templateTable/templateTable.js